export enum ZnsCampaignStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  DEACTIVE = "DEACTIVE",
  COMPLETED = "COMPLETED",
}

export enum ZnsCampaignType {
  MANUAL = "MANUAL",
  AUTO = "AUTO",
}

export enum ZnsCampaignTargetAudience {
  CUSTOMER = "CUSTOMER",
  OUTLET = "OUTLET",
}

export enum ZnsSendingMode {
  IMMEDIATE = "IMMEDIATE",
  SCHEDULED = "SCHEDULED",
  EVENT_TRIGGERED = "EVENT_TRIGGERED",
  CRON_SCHEDULED = "CRON_SCHEDULED",
}

export interface IZnsCampaign {
  id?: string;
  name: string;
  description: string;
  znsTemplateId: string;
  znsTemplateName?: string;
  type: ZnsCampaignType;
  targetAudience: ZnsCampaignTargetAudience;
  status: ZnsCampaignStatus;
  validFrom?: string;
  validTo?: string;
    znsConfiguration?: {
    recipientFilePath?: string;
    activeFrom?: string;
    activeTo?: string;
    sendingMode?: ZnsSendingMode;
    scheduledSendTime?: string;
    cronExpression?: string;
    rules?: any[];
  };
}

export interface IZnsConfigurationResponse {
  id: string;
  znsCampaignId: string;
  znsCampaignName: string;
  znsTemplateName: string;
  znsTemplateId: string;
  templateId: string;
  version: number;
  activeFrom: string;
  activeTo: string;
  isCurrent: boolean;
  recipientFilePath: string;
  sendingMode: ZnsSendingMode;
  scheduledSendTime: string;
  cronExpression: string;
  createdDate: string;
  modifiedDate: string;
  createdBy: string;
  modifiedBy: string;
}

export interface IZnsCampaignResponse {
  id: string;
  name: string;
  description: string;
  znsTemplateId: string;
  znsTemplateName: string;
  type: ZnsCampaignType;
  targetAudience: ZnsCampaignTargetAudience;
  status: ZnsCampaignStatus;
  validFrom: string;
  validTo: string;
  createdDate: string;
  modifiedDate: string;
  createdBy: string;
  modifiedBy: string;
  znsConfigurations: IZnsConfigurationResponse[];
}

export interface IZnsCampaignListParams {
  SearchTerm?: string;
  ZnsTemplateId?: string;
  Status?: ZnsCampaignStatus;
  Type?: ZnsCampaignType;
  TargetAudience?: ZnsCampaignTargetAudience;
  PageNumber?: number;
  PageSize?: number;
}

export interface IZnsCampaignListResponse {
  data: IZnsCampaign[];
  total: number;
}

export interface IUploadRecipientsResponse {
  errorFilePath: string;
  filePath: string;
  rowCount: number;
  errorCount: number;
  hasErrors: boolean;
}

export interface IOlCampaignListParams {
  SearchTerm?: string;
  PlatformType?: string;
  PageNumber?: number;
  PageSize?: number;
  SortDirection?: "ASC" | "DESC";
}

export interface IOlCampaign {
  id: string;
  name: string;
  status: string;
  totalUser?: number;
}

export interface IOlCampaignListResponse {
  results: IOlCampaign[];
  totalCount: number;
}

/** Query params for GET /api/ZnsCampaign/v1/all/configurations */
export type ZnsConfigurationReportSortBy =
  | "CreatedDate"
  | "ModifiedDate"
  | "Version"
  | "ActiveFrom"
  | "ActiveTo"
  | "SendingMode";

export interface IZnsCampaignConfigurationListParams {
  SendingMode?: string;
  IsCurrent?: boolean;
  ActiveFromStart?: string;
  ActiveFromEnd?: string;
  ActiveToStart?: string;
  ActiveToEnd?: string;
  CreatedOnStart?: string;
  CreatedOnEnd?: string;
  ZnsCampaignId?: string;
  ZnsCampaignName?: string;
  ZnsTemplateId?: string;
  TemplateId?: string;
  SortBy?: ZnsConfigurationReportSortBy;
  SortDirection?: "ASC" | "DESC";
  PageNumber?: number;
  PageSize?: number;
  SearchTerm?: string;
}

/** Row in GET /api/ZnsCampaign/v1/all/configurations response */
export interface IZnsCampaignConfigurationListItem {
  id: string;
  znsCampaignId: string;
  znsCampaignName: string;
  znsTemplateName?: string;
  znsTemplateId: string;
  templateId: string;
  version: number;
  activeFrom?: string;
  activeTo?: string;
  isCurrent: boolean;
  recipientFilePath?: string;
  sendingMode: string;
  cronExpression?: string;
  createdDate: string;
  modifiedDate?: string;
  createdBy?: string;
  modifiedBy?: string;
  targetAudience: ZnsCampaignTargetAudience;
  rules?: any[];
}

export interface IZnsCampaignConfigurationListResponse {
  totalCount: number;
  results: IZnsCampaignConfigurationListItem[];
}

export interface ConditionRow {
  id: string;
  fieldName: string;
  comparisonOperator: string;
  value?: string;
  logicalOperator?: "AND" | "OR";
}

/** Serializable payload for saga: submit auto ZNS campaign from AutoSendingFormPage */
export interface SubmitAutoZnsCampaignPayload {
  campaignName: string;
  znsTemplateId: string;
  recipientFilePath: string | null | undefined;
  mode: "customer" | "outlet-owner";
  sendConditions: {
    cron: string;
    endDateIso: string | null;
    campaignConfigs: any[];
  } | null;
}

/** Body for PUT /api/ZnsCampaign/v1/{znsCampaignId}/configurations/{configurationId} */
export interface UpdateZnsCampaignConfigurationPayload {
  configurationId: string;
  isCurrent: boolean;
}

/**
 * Deactivate flow (report row): set configuration isCurrent false, then campaign status DEACTIVE.
 */
export interface DeactivateZnsCampaignPayload {
  znsCampaignId: string;
  configurationId: string;
  refetchParams: IZnsCampaignConfigurationListParams;
}
